import { environment } from "../../../../environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { catchError, tap } from "rxjs/operators";

var apiRequests = `${environment.BACKEND_URL}/upload-attachments`;
// var apiRequests = `${environment.BACKEND_URL}/archivo`;

@Injectable({
  providedIn: "root",
})
export class dataService {
  data = null;

  constructor(private http: HttpClient) {}

  httpHeader = {
    headers: new HttpHeaders({
      // 'Content-Type': 'application/json',
      Authorization: "Basic " + btoa(localStorage.getItem("token_jwt")),
    }),
  };
}
